export const userSelectedLocationInfoSelector = (state) =>
    state.user.selectedLocation;
export const userCityIdSelector = (state) => state.user.selectedLocation.cityId;
export const userAgencyIdSelector = (state) => state.user.selectedLocation.agencyId;
export const userInAgencyIdSelector = (state) => state.user.personalInformation.inAgency;

/**
 * The effective agency ID for the current user.
 * For LYT roles → set by the sidebar agency selector.
 * For non-LYT roles → set from their assigned agency on login.
 */
export const userEffectiveAgencyIdSelector = (state) => state.user.agencyId;
export const userIdSelector = (state) => state.user.personalInformation.user_id;
export const userEmailSelector = (state) => state.user.personalInformation.email;
export const userPersonalInformationSelector = (state) => state.user.personalInformation;
export const userThemeSelector = (state) => state.user.theme;
export const userRoleSelector = (state) => state.user.personalInformation.usertype;

export const userPermissionsSelector = (state) => state.user.personalInformation.role.roleParse;
export const userChangePasswordSelector = (state) => state.user.changePassword;
export const userUpdatedSelector = (state) => state.user.updateUser;
